"use client";

import { createContext, type ReactNode, useContext, useMemo } from "react";
import {
	EDITABLE_FIELD_HEADER_VARIANT_DEFAULT,
	type EditableFieldHeaderVariant,
} from "./chrome";

export interface EditableFieldContextValue {
	/** Whether the field content is in edit mode. */
	editing: boolean;
	/** Header surface variant (plain solid vs brand gradient). */
	headerVariant: EditableFieldHeaderVariant;
}

const EditableFieldContext = createContext<EditableFieldContextValue>({
	editing: false,
	headerVariant: EDITABLE_FIELD_HEADER_VARIANT_DEFAULT,
});

export function EditableFieldProvider({
	editing,
	headerVariant = EDITABLE_FIELD_HEADER_VARIANT_DEFAULT,
	children,
}: {
	editing: boolean;
	headerVariant?: EditableFieldHeaderVariant;
	children: ReactNode;
}) {
	const value = useMemo(
		() => ({ editing, headerVariant }),
		[editing, headerVariant],
	);
	return (
		<EditableFieldContext.Provider value={value}>
			{children}
		</EditableFieldContext.Provider>
	);
}

export function useEditableField(): EditableFieldContextValue {
	return useContext(EditableFieldContext);
}
